import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { FormInput } from 'components/form';
import { NoteAttribute } from '../../api';

export const Notes = ({
  note,
  onChange,
  isLoading,
}: {
  note: NoteAttribute;
  onChange: (nextValue: string) => void;
  isLoading: boolean;
}) => {
  const [value, setValue] = useState<string>(note.value ?? '');

  useEffect(() => {
    if (note.value) setValue(note.value);
    return () => {
      setValue('');
    };
  }, [note.value]);

  return (
    <Stack gap="0.5rem">
      <Typography variant="body1">{note.name}:</Typography>
      <FormInput
        disabled={isLoading}
        variant="outlined"
        value={value}
        onChange={value => setValue(value)}
        onBlur={() => {
          if (!value || value === note.value) return;
          onChange(value.trim());
        }}
      />
    </Stack>
  );
};
